import "./InputTextareaDirective.scss";

import type { IDirective } from "angular";
import { module } from "angular";

import { InputDirectiveFunctions } from "App/Modules/Gui/Directives";

export default class InputTextareaDirective implements IDirective {
    public priority = 1000;

    public restrict = "E";

    public scope = {
        irLabel: "<",
        ngModel: "=",
    };

    public template: string;

    public link = InputDirectiveFunctions.link; // eslint-disable-line @typescript-eslint/unbound-method

    public compile = InputDirectiveFunctions.compile(this.link);

    constructor() {
        this.template = `<div class="input-textarea">
                            <textarea class="form-control" aa-field-group="ngModel" aa-label="{{irLabel | translate}}"></textarea>
                         </div>`;
    }
}

module("mmGui").directive("irInputTextarea", () => new InputTextareaDirective());
